import { useMediaQuery } from "react-responsive"
import { Link, useLocation } from "react-router-dom"
import { useEffect, useRef, useState } from "react"
import HLink from "../common/HLink"
import "./Header.css"

const HIDE_DELAY = 300

const Header = () => {

    const [functionalitiesVisible, setFunctionalitiesVisible] = useState(false)
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false)
    const [senecaVisible, setSenecaVisible] = useState(false)
    const isMobile = useMediaQuery({ maxWidth: 1280 })
    const [pathname, setPathname] = useState()
    const location = useLocation()
    const senecaTimer = useRef(null)
    const funcTimer = useRef(null)
    const senecaTriggerRef = useRef(null)
    const funcTriggerRef = useRef(null)


    useEffect(() => {
        setPathname(window.location.pathname)
    }, [location])


    /**
     * Funciones para movil
     * @param {*} visibility 
     */
    const setMenuVisibility = (visibility) => {

        if (!visibility) {
            setSenecaVisible(false)
            setFunctionalitiesVisible(false)
        }
        setMobileMenuVisible(visibility)
    }

    /**
     * Funciones para movil
     * @param {*} visibility 
     */
    const toggleSenecaVisibility = () => {
        setSenecaVisible(!senecaVisible)
    }

    /**
     * Funciones para movil
     * @param {*} visibility 
     */
    const toggleFunctionalitiesVisibility = () => {
        setFunctionalitiesVisible(!functionalitiesVisible)
    }

    const showSeneca = () => {
        clearTimeout(senecaTimer.current)
        setSenecaVisible(true)
    }
    const hideSenecaDelayed = () => {
        senecaTimer.current = setTimeout(() => setSenecaVisible(false), HIDE_DELAY)
    }
    const handleSenecaKeyDown = (e) => {
        if (e.key === "Escape") {
            setSenecaVisible(false)
            senecaTriggerRef.current?.focus()
        }
    }

    const showFunc = () => {
        clearTimeout(funcTimer.current)
        setFunctionalitiesVisible(true)
    }
    const hideFuncDelayed = () => {
        funcTimer.current = setTimeout(() => setFunctionalitiesVisible(false), HIDE_DELAY)
    }
    const handleFuncKeyDown = (e) => {
        if (e.key === "Escape") {
            setFunctionalitiesVisible(false)
            funcTriggerRef.current?.focus()
        }
    }

    function hideMenuMobile() {
        setMenuVisibility(false)
    }


    if (isMobile)
        return (
            <header className="mobile-header">

                <section className="mobile-header-section">
                    <Link to="/" onClick={hideMenuMobile}>
                        <img alt="Imagen" src="/images/seneca.png" className="logo" />
                    </Link>
                    <button
                        type="button"
                        className="bi bi-list icon-big burguer"
                        aria-label={mobileMenuVisible ? "Cerrar menú" : "Abrir menú"}
                        aria-expanded={mobileMenuVisible}
                        onClick={() => setMenuVisibility(!mobileMenuVisible)}
                    ></button>
                </section>

                <nav className={(mobileMenuVisible) ? "header-nav-mobile" : "header-nav-mobile hidden"} >

                    <HLink path="/seneca/" pathname={pathname} fClick={() => toggleSenecaVisibility()} expanded={senecaVisible} text="Séneca" />

                    <section id="seneca-subsection" className={senecaVisible ? "header-subsection-s-mobile" : "header-subsection-s-mobile hidden"}>
                        <nav className="flex col">

                            <HLink path="/seneca/ciudadanos" pathname={pathname} fClick={() => hideMenuMobile()} text={"Para ciudadanos"} isLink isBlue />
                            <HLink path="/seneca/departamento-de-publicaciones" pathname={pathname} fClick={() => hideMenuMobile()} text="Para departamento de publicaciones" isLink isBlue />
                            <HLink path="/seneca/prensa-y-comunicacion" pathname={pathname} fClick={() => hideMenuMobile()} text="Para prensa y comunicación" isLink isBlue />
                            {/* <HLink path="/seneca/empresas" pathname={pathname} fClick={() => hideMenuMobile()} text="Para Empresas" isLink isBlue /> */}

                        </nav>
                    </section>

                    <HLink path="/funcionalidades/" pathname={pathname} fClick={() => toggleFunctionalitiesVisibility()} expanded={functionalitiesVisible} text="Funcionalidades" />

                    <section id="functionalities-subsection" className={functionalitiesVisible ? "header-subsection-s-mobile" : "header-subsection-s-mobile hidden"}>
                        <nav className="flex col">

                            <HLink path="/funcionalidades/grabacion-y-catalogacion" pathname={pathname} fClick={() => hideMenuMobile()} text="Grabación y catalogación" isLink isBlue />
                            <HLink path="/funcionalidades/publicacion" pathname={pathname} fClick={() => hideMenuMobile()} text="Publicación" isLink isBlue />
                            <HLink path="/funcionalidades/transcripcion" pathname={pathname} fClick={() => hideMenuMobile()} text="Transcripción" isLink isBlue />
                            <HLink path="/funcionalidades/administracion" pathname={pathname} fClick={() => hideMenuMobile()} text="Adminisitración" isLink isBlue />

                        </nav>
                    </section>

                    <HLink path="/servicios" pathname={pathname} fClick={() => hideMenuMobile()} text="Servicios" isLink />
                    <HLink path="/video-acta" pathname={pathname} fClick={() => hideMenuMobile()} text="Video-acta" isLink />
                    <HLink path="/conocenos" pathname={pathname} fClick={() => hideMenuMobile()} text="Nosotros" isLink />
                    <HLink path="/tecnologia" pathname={pathname} fClick={() => hideMenuMobile()} text="Tecnología" isLink />
                    {/* <HLink path="/cosital" pathname={pathname} fClick={() => hideMenuMobile()} text="Cosital" isLink /> */}
                    <HLink path="/contacto" pathname={pathname} fClick={() => hideMenuMobile()} text="Contacto" isLink />
                    <HLink path="/legal" pathname={pathname} fClick={() => hideMenuMobile()} text="Legal" isLink />

                </nav>

                <section className="separator"></section>
            </header>
        )
    else
        return (

            <header className="desktop-header">
                <section className="desktop-header-section">

                    <Link to="/">
                        <img alt="Imagen" src="/images/seneca.png" className="logo" />
                    </Link>

                    <nav className="header-nav">

                        <HLink path="/seneca/" pathname={pathname} fMouseEnter={showSeneca} fMouseLeave={hideSenecaDelayed} fFocus={showSeneca} fBlur={hideSenecaDelayed} fKeyDown={handleSenecaKeyDown} expanded={senecaVisible} triggerRef={senecaTriggerRef} text="Séneca" />

                        <section id="seneca-subsection" className={senecaVisible ? "flex gap-10 header-subsection-s col acenter" : "flex gap-10 header-subsection-s col hidden"} onMouseEnter={showSeneca} onMouseLeave={hideSenecaDelayed} onFocus={showSeneca} onBlur={hideSenecaDelayed}>
                            <nav className="flex gap-10">

                                <HLink path="/seneca/ciudadanos" pathname={pathname} fClick={() => hideMenuMobile()} text={"Para ciudadanos"} isWhite isLink />
                                <HLink path="/seneca/departamento-de-publicaciones" pathname={pathname} fClick={() => hideMenuMobile()} text="Para departamento de publicaciones" isWhite isLink />
                                <HLink path="/seneca/prensa-y-comunicacion" pathname={pathname} fClick={() => hideMenuMobile()} text="Para prensa y comunicación" isWhite isLink />
                                {/* <HLink path="/seneca/empresas" pathname={pathname} fClick={() => hideMenuMobile()} text="Para Empresas" isWhite isLink /> */}

                            </nav>
                        </section>

                        <HLink path="/funcionalidades/" pathname={pathname} fMouseEnter={showFunc} fMouseLeave={hideFuncDelayed} fFocus={showFunc} fBlur={hideFuncDelayed} fKeyDown={handleFuncKeyDown} expanded={functionalitiesVisible} triggerRef={funcTriggerRef} text="Funcionalidades" />

                        <section id="functionalities-subsection" className={functionalitiesVisible ? "flex gap-10 header-subsection-f col acenter" : "flex gap-10 header-subsection-f col hidden"} onMouseEnter={showFunc} onMouseLeave={hideFuncDelayed} onFocus={showFunc} onBlur={hideFuncDelayed}>
                            <nav className="flex gap-10">

                                <HLink path="/funcionalidades/grabacion-y-catalogacion" pathname={pathname} fClick={() => hideMenuMobile()} text={"Grabación y catalogación"} isWhite isLink />
                                <HLink path="/funcionalidades/publicacion" pathname={pathname} fClick={() => hideMenuMobile()} text={"Publicación"} isWhite isLink />
                                <HLink path="/funcionalidades/transcripcion" pathname={pathname} fClick={() => hideMenuMobile()} text={"Transcripción"} isWhite isLink />
                                <HLink path="/funcionalidades/administracion" pathname={pathname} fClick={() => hideMenuMobile()} text={"Administración"} isWhite isLink />

                            </nav>
                        </section>

                        <HLink path="/servicios" pathname={pathname} fClick={() => hideMenuMobile()} text="Servicios" isLink />
                        <HLink path="/video-acta" pathname={pathname} fClick={() => hideMenuMobile()} text="Video-acta" isLink />
                        <HLink path="/conocenos" pathname={pathname} fClick={() => hideMenuMobile()} text="Nosotros" isLink />
                        <HLink path="/tecnologia" pathname={pathname} fClick={() => hideMenuMobile()} text="Tecnología" isLink />
                        {/* <HLink path="/cosital" pathname={pathname} fClick={() => hideMenuMobile()} text="Cosital" isLink /> */}
                        <HLink path="/contacto" pathname={pathname} fClick={() => hideMenuMobile()} text="Contacto" isLink />
                        <HLink path="/legal" pathname={pathname} fClick={() => hideMenuMobile()} text="Legal" isLink />

                    </nav>

                </section>

                <section className="separator"></section>

            </header>
        )


}

export default Header